/* eslint-disable */
import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { MDBDataTable } from 'mdbreact';
import Nav from 'react-bootstrap/Nav';
import { Row, Col } from 'react-bootstrap';

class FilteredTable extends React.Component {
    constructor(props) {
        super(props);

        let reservedInstanceData = [];
        let onDemandData = [];
        let allOnDemandData = []
        let allReservedInstanceData = []
        let pricing = this.props.data;
        pricing.map(price => {
            price.price = parseFloat(price.price).toFixed(2);
            if (price.com == 'OD') {
                allOnDemandData.push(price)
            }
            else {
                if (price.price) {
                    allReservedInstanceData.push(price)
                }
            }

            if (price.specs == 'G01' && price.com == 'OD') {
                onDemandData.push(price)
            }
            else {
                price.specs == 'G01' && price.com == 'NU' && price.mod == '1Y' && reservedInstanceData.push(price)
            }

        })
        const columns = [
            {
                label: 'Name',
                field: 'name',
                sort: 'asc',
            },
            {
                label: 'vCPU',
                field: 'vcpu',
                // sort: 'asc', 
                width: 200
            },
            {
                label: 'RAM',
                field: 'ram',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Hourly Pricing',
                field: 'hourlyPricing',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Monthly Pricing',
                field: 'monthlyPricing',
                sort: 'asc',
                width: 150
            },
        ];
        const DataOnDemand = {
            columns,
            rows: onDemandData
        }
        const DataReservedInstance = {
            columns,
            rows: reservedInstanceData
        }

        this.state = {
            allOnDemandData: allOnDemandData,
            allReservedInstanceData: allReservedInstanceData,
            reservedData: DataReservedInstance,
            demandData: DataOnDemand,
            flavor: 'G01',
            payment: 'NU',
            year: '1Y',
            mobile: false,
        }
    }
    componentDidMount() {
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.setState({ mobile: true });
        }
    }
    render() {
        // const handleSelectOperation = (eventKey) => {
        //     let data = [];
        //     this.state.allOnDemandData.map(price => {
        //         if (price.os_name.toLowerCase().includes(eventKey) && price.specs.includes(this.state.flavor))
        //             data.push(price)
        //     })
        //     let updatedData = this.state.demandData;
        //     updatedData.rows = data;
        //     this.setState({
        //         operatingSystem: eventKey,
        //         demandData: updatedData
        //     })
        // }
        // const handleSelectOperationReserved = (eventKey) => {
        //     let data = [];
        //     this.state.allReservedInstanceData.map(price => {
        //         if (price.os_name.toLowerCase().includes(eventKey) && price.specs.includes(this.state.flavor) && price.com.includes(this.state.payment) && price.mod.includes(this.state.year)) {
        //             data.push(price)
        //         }
        //     })
        //     let updatedData = this.state.reservedData;
        //     updatedData.rows = data;
        //     this.setState({
        //         operatingSystem: eventKey,
        //         reservedData: updatedData
        //     })

        // }
        const handleSelectFlavor = (eventKey) => {
            let onDemand = [];
            this.state.allOnDemandData.map(price => {
                if (price.specs.includes(eventKey)) {
                    onDemand.push(price)
                }
            })
            let updatedData = this.state.demandData;
            updatedData.rows = onDemand;
            this.setState({
                flavor: eventKey,
                demandData: updatedData
            })
        }
        const handleSelectFlavorResererved = (eventKey) => {
            let onReserved = [];
            console.log(this.state.allReservedInstanceData, 'reservedinstancedta')
            this.state.allReservedInstanceData.map(price => {
                if (price.specs.includes(eventKey) && price.com.includes(this.state.payment) && price.mod.includes(this.state.year)) {
                    onReserved.push(price)
                }
            })
            let updatedData = this.state.reservedData;
            updatedData.rows = onReserved;
            this.setState({
                flavor: eventKey,
                reservedData: updatedData
            })
        }
        const handleSelectPaymentReserved = (eventKey) => {
            let onReserved = [];
            this.state.allReservedInstanceData.map(price => {
                console.log(price, 'priceonreserved')
                if (price.com.includes(eventKey) && price.specs.includes(this.state.flavor) && price.mod.includes(this.state.year)) {

                    onReserved.push(price)
                }
            })
            let updatedData = this.state.reservedData;
            updatedData.rows = onReserved;
            this.setState({
                payment: eventKey,
                reservedData: updatedData
            })
        }
        const handleSelectYear = (eventKey) => {
            let onReserved = [];
            this.state.allReservedInstanceData.map(price => {
                if (price.mod.includes(eventKey) && price.specs.includes(this.state.flavor) && price.com.includes(this.state.payment)) {
                    onReserved.push(price)
                }
            })
            let updatedData = this.state.reservedData;
            updatedData.rows = onReserved;
            this.setState({
                year: eventKey,
                reservedData: updatedData
            })
        }
        const { mobile } = this.state

        return (
            <div className='tabsData'>
                <Tabs defaultActiveKey="On Demand" transition={false} id="noanim-tab-example" className='tableTabs container' >
                    <Tab className="container demand-tab" eventKey="On Demand" title="On Demand" md='6'>
                        <Row className='pricingFilters'>
                            {/* <Col md='6'>
                                <Nav variant="pills" defaultActiveKey={this.state.operatingSystem} onSelect={handleSelectOperation} md='6' className={!mobile ? 'osNav osButtons' : 'osNav d-inline-block mb-3'}>
                                    <Nav.Item className='osLabel'>
                                        Operation System
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="linux">Linux</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="windows">Windows</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="redhat" >Redhat</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col> */}
                            <Col md='6'>
                                <Nav className={!mobile ? "flavours-nav" : "flavours-nav d-inline-block mt-3 mb-3"} variant="pills" defaultActiveKey={this.state.flavor} onSelect={handleSelectFlavor}>
                                    <Nav.Item className='osLabel'>
                                        Flavours
                                </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="G01">General Purpose 1</Nav.Link>
                                    </Nav.Item>
                                    {/* <Nav.Item>
                                        <Nav.Link eventKey="G02">General Purpose 2</Nav.Link>
                                    </Nav.Item> */}
                                    <Nav.Item>
                                        <Nav.Link eventKey="M01" >Memory Optimized</Nav.Link>
                                    </Nav.Item>
                                </Nav>

                            </Col>
                        </Row>
                        <MDBDataTable
                            responsive
                            striped
                            bordered
                            small
                            headCheckboxID='id3'
                            bodyCheckboxID='checkboxes3'
                            data={{ columns: this.state.demandData.columns, rows: this.state.demandData.rows }} />
                    </Tab>
                    <Tab className="container reserved-tab" eventKey="Reserved Instance" title="Reserved Instance" md='6'>
                        <Row className='pricingFilters'>
                            <Col md='6'>
                                <Nav className={!mobile ? "flavours-nav yearButtons" : "osNav d-inline-block mt-3 mb-3"} variant="pills" defaultActiveKey={this.state.year} onSelect={handleSelectYear} >
                                    <Nav.Item className={!mobile ? 'paymentLabel padding-label' : 'paymentLabel'}>
                                        Year
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="1Y">1 year</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="3Y">3 years</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>

                            <Col md='6'>
                                <Nav className={!mobile ? "flavours-nav" : "osNav d-inline-block mt-3 mb-3"} variant="pills" defaultActiveKey={this.state.flavor} onSelect={handleSelectFlavorResererved}>
                                    <Nav.Item className='osLabel'>
                                        Flavours
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="G01">General Purpose 1</Nav.Link>
                                    </Nav.Item>
                                    {/* <Nav.Item>
                                        <Nav.Link eventKey="G02">General Purpose 2</Nav.Link>
                                    </Nav.Item> */}
                                    <Nav.Item>
                                        <Nav.Link eventKey="M01" >Memory Optimized</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>


                        </Row>
                        <Row className='pricingFilters'>
                            {/* <Col md='6'>
                                <Nav variant="pills" defaultActiveKey={this.state.operatingSystem} onSelect={handleSelectOperationReserved} md='6' className={!mobile ? 'osNav osButtons':'osNav d-inline-block mt-3 mb-3'}>
                                    <Nav.Item className='osLabel'>
                                        Operation System
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="linux">Linux</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="windows">Windows</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="redhat" >Redhat</Nav.Link>
                                    </Nav.Item>
                                </Nav>

                            </Col> */}

                            <Col md='6'>
                                <Nav variant="pills" defaultActiveKey={this.state.payment} onSelect={handleSelectPaymentReserved} md='6' className={!mobile ? 'paymentNav paymentButtons' : "paymentNav d-inline-block mt-3 mb-3"}>
                                    <Nav.Item className='paymentLabel'>
                                        Payment
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="NU">No Upfront</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="PU">Partial Upfront</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="FU" >Full Up</Nav.Link>
                                    </Nav.Item>
                                </Nav>

                            </Col>
                        </Row>
                        <MDBDataTable
                            responsive
                            striped
                            bordered
                            small
                            headCheckboxID='id2'
                            bodyCheckboxID='checkboxes2'
                            data={{ columns: this.state.reservedData.columns, rows: this.state.reservedData.rows }}
                        />
                    </Tab>
                </Tabs>
            </div >
        );
    }
}
export default FilteredTable;